import { connect } from 'react-redux'
import PriceDiscount from './view'

export default connect(null, {})(PriceDiscount)
